import { FolderPermission } from '@tabeeb/enums'

export const hasFolderPermission = (permissions, permission) => {
  if (!permissions) {
    return false
  }

  return permissions.includes(permission)
}

export const getShowFolderMenu = (folder) => {
  return (
    folder.IsDeleted ||
    hasFolderPermission(folder.FolderUsersPermissions, FolderPermission.DeleteFolder) ||
    hasFolderPermission(folder.FolderUsersPermissions, FolderPermission.LeaveFolder) ||
    hasFolderPermission(folder.FolderUsersPermissions, FolderPermission.AddUsers) ||
    hasFolderPermission(folder.FolderUsersPermissions, FolderPermission.EditUsers)
  )
}
